import { Divider, List, ListItem, Typography } from "@mui/material";
import { Box, Grid, Stack } from "@mui/system";
import { LiveCodeBlock } from "../../LiveCodeBlock";
import VerticalLinearStepper from "../VerticalLinearStepper";

export const KdappontCssLesson1 = () => {
  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "🎨 Wat is CSS?",
          description: ``,
          content: (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 15 }}>
              <section>
                <Box sx={{ position: "relative" }}>
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "50px",
                      boxSizing: "border-box",
                    }}
                  >
                    <Box
                      sx={{
                        background: "rgba(255, 255, 255, 0.3)",
                        borderRadius: "15px",
                        backdropFilter: "blur(15px)",
                        padding: "20px",
                        // border: "5px solid rgba(255,255,255,0.2)",
                        boxShadow: "2px 2px 15px rgba(0,0,0,0.3)",
                      }}
                    >
                      <Typography
                        variant="h1"
                        sx={{
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          fontWeight: "bold",
                          margin: "20px",
                          color: "white",
                          backgroundSize: "400% 400%",
                          textShadow: "10px 10px 20px rgba(0,0,0,0.3)",
                        }}
                      >
                        CSS
                      </Typography>

                      <List
                        sx={{
                          textShadow: "1px 1px 1px #ffffff8a",
                        }}
                      >
                        <ListItem>
                          <Typography variant="body1">
                            👉 Cascading Style Sheets
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            👉 Beschrijft hóe elementen getoond worden op het
                            scherm <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Kleur, positionering &
                            grootte, animaties, fonts, etc.
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            👉 Aparte CSS Files
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            👉 Controleert de layout van meerdere pagina's
                            tegelijk
                          </Typography>
                        </ListItem>
                      </List>
                    </Box>
                  </Box>
                  <Box
                    component="video"
                    src="/presentation-data/KDAPPONT2/css-intro/css-intro-x2.mp4"
                    autoPlay
                    loop
                    muted
                    sx={{
                      width: "100%",
                      borderRadius: 2,
                      boxShadow: 3,
                    }}
                  />
                </Box>
              </section>
            </Box>
          ),
        },
        {
          label: "⚙️ CSS Gebruiken",
          description: "",
          content: (
            <Grid container>
              <Grid size={9}>
                <section>
                  <LiveCodeBlock
                    live={false}
                    code={`<!-- index.html -->
<!DOCTYPE html>
<html>
    <head>
        <link type="text/css" rel="stylesheet" href="stylesheet.css" />
    </head>

    <body>
      <h1>CSS is awesome</h1>
    </body>
</html>`}
                  />
                  <Divider />

                  <Box sx={{ position: "relative" }}>
                    <img
                      style={{
                        position: "absolute",
                        padding: 5,
                        background: "#FFF",
                        right: 125,
                        top: 50,
                        width: "50%",
                        borderRadius: "20px",
                        zIndex: 2,
                      }}
                      src="/presentation-data/KDAPPONT2/css-intro/css_selector.gif"
                      width="100%"
                      alt=""
                    />
                    <LiveCodeBlock
                      live={false}
                      language="css"
                      code={`/*stylesheet.css*/
h1 {
    color: green;
    font-family: Impact;
    font-size: 50px;
    text-align: center;
}`}
                    />
                  </Box>
                </section>
              </Grid>

              <Grid size={3}>
                <img
                  src="/presentation-data/KDAPPONT2/css-intro/css-result.png"
                  width="100%"
                  alt=""
                />
              </Grid>
            </Grid>
          ),
        },
        {
          label: "👨🏼‍🏫 Demo",
          description: `Praktijkvoorbeelden`,
        },
        {
          label: "🚀 Aan de slag!",
          description: `Digitaal lesmateriaal ➡️ KD Appont ➡️ Module 2 :: CSS ➡️ Lessen ➡️ LES 1`,
          content: (
            <>
              <List>
                <ListItem>
                  <Typography variant="body1">
                    📄 Logboek: Screenshot je gebruikte code per hoofdstuk
                  </Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body1">
                    🎓 Maak de W3Schools quizes!
                  </Typography>
                </ListItem>
              </List>
              <Divider />
              <List>
                <ListItem>
                  <Typography variant="body1">
                    💡 VSCode: Installeer "Live Server"
                  </Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body1">
                    💡 Gebruikt CTRL + / of CMD + / om een regel om te zetten in
                    comments
                  </Typography>
                </ListItem>
              </List>
            </>
          ),
        },
      ]}
    />
  );
};
